import {
  AskMarketValue,
  BidMarketValue,
  OrderMarketValue,
} from '@/types/utilities';
import { genMarketValueChartDataForSku } from '@/utilites/market-value';
import { useMemo } from 'react';

const useMarketValues = (
  orders: OrderMarketValue[],
  bids: BidMarketValue[],
  asks: AskMarketValue[],
  retailPrice: number
) => {
  return useMemo(() => {
    const marketValueChartData = genMarketValueChartDataForSku(
      asks,
      bids,
      orders,
      retailPrice
    ).marketValueChartData;

    const filteredMarketValueChartData = marketValueChartData.filter(
      (data: { value: number; created: string }) => data.value !== -1
    );

    return filteredMarketValueChartData;
  }, [orders, bids, asks]);
};

export default useMarketValues;
